import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { isScullyRunning } from '@scullyio/ng-lib';

@Injectable({
  providedIn: 'root'
})
export class ClarityService {
    private readonly  idScript = "clarityIdeal" 
    private add = false;
  constructor(
    @Inject(DOCUMENT) private tag: Document) {
    
  }

  loadClarity(clarityScript:string){

    if(!isScullyRunning() && !document.getElementById(this.idScript)){
      const script = this.tag.createElement("script");
      script.id = this.idScript;
      script.innerHTML = clarityScript;
      this.tag.head.appendChild(script);
      this.add = true
    } 
  }
  
}